import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Slide,
    IconButton,
    Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

function DocumentViewDialog({
    blobUrl,
    documentView,
    setDocumentView
}) {
    // console.log("blobUrl", blobUrl)
    const { t } = useTranslation();
    const onClose = () => {
        setDocumentView(false)
    }
    return (
        documentView && (
            <Draggable handle="#draggable-dialog-title">
                <Dialog
                    open={documentView}
                    TransitionComponent={Transition}
                    fullWidth
                    maxWidth="md"
                    id="draggable-dialog-title"
                    PaperProps={{
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            minHeight: "100vh",
                            maxHeight: "100vh",
                            width:"50%",
                            position: "absolute",
                            right: 0, 
                        },
                    }}
                    onClose={onClose}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{
                        backgroundColor: "#00913E",
                        color: "white",
                        height: "4rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>
                        {t("Payment Documents")}
                        <IconButton
                            color="inherit"
                            onClick={onClose}
                            edge="end"
                            style={{
                                position: "absolute",
                                top: 0,
                                right: 5,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ flex: "1 1 auto" }}>
                        <iframe
                            title="PDF Viewer"
                            src={blobUrl}
                            width="100%"
                            // height="100%"
                            height="800px"
                            style={{ border: "none" }}
                        ></iframe>
                    </DialogContent>
                    <Divider />
                </Dialog>
            </Draggable>
        )
    );
}

export default DocumentViewDialog;
